<template>
  <div id="icas" :class="{'micro-app-icas':$isMicroApp}">
    <el-cookie-terms v-show="isShowCookieTerms" ref="closeDialog" />
    <!-- <top-switch-site /> -->
    <router-view />
    <el-terms-dialog
      ref="elTermsDialog"
      :terms="cookie_terms"
      :cookie-dialog="cookie_terms.type === cookieKey"
      :entry-from="'copyright'"
      @agree="changeVal"
    />
    <div v-if="appLoading" class="global-loading">
      <div class="ball-spin-fade-loader">
        <div v-for="(key, index) in new Array(8)" :key="index" />
      </div>
    </div>
    <!-- 不是os -->
    <FloatButtonList v-if="!isOS && isFromSFBuy && uiConfig.isHelpCenterEnabled" />
    <FloatServiceIUOP v-else-if="isFromIUOP && uiConfig.isHelpCenterEnabled" />
    <FloatServiceOS v-else-if="isFromIUOPOS && uiConfig.isHelpCenterEnabled" />

    <float-service v-else-if="!isOS && !isChildApp && !isFromSFBuy && uiConfig.isHelpCenterEnabled && isShowFloatService" />
    <MessageNotice />
    <!-- <Keep-alive>
      <Recommend v-if="showRecommend" />

    </Keep-alive> -->
  </div>
</template>

<script>
import Cookies from 'js-cookie'
// import Logger from '@sf-intl/reporter-sdk'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ElCookieTerms from '@/components/CookieTerms'
// import TopSwitchSite from '@/components/TopSwitchSite'
import ElTermsDialog from '@/components/TermsDialog'
import FloatService from '@/components/FloatService'
import FloatServiceIUOP from '@/components/FloatServiceIUOP'
import FloatServiceOS from '@/components/FloatServiceOS'

import { removeOptionCookie, removeAnalyticsListCookie } from '@/utils/cookieOperation'
import { getHtmlParams, getUrlKey, setPrimaryThemeColors } from '@/utils'
import { setToken } from '@/utils/auth'

import { getEnvObj } from '@/utils/env'
// import initConfig from '@/reporter/config/lg'
// import { addWebFunny } from '@/webfunny.config'
import { isOS, isId, isVn, SF_IUOP_OS_ID, SF_IUOP_OS, SF_BUY, AMAZON, GLS, ACS, SF_IUOP, IUOP_BOSCH, IFTP, ISCO, ISCO_OS, ISCOUS, CBS, SDM, OPENAPI, ESG_THACSP_CORE_OS, CAIR } from '@/utils/constant'
// import { checkGrayVersion } from '@/api/common/public'

import { addIeeFeedbackScript } from '@/utils/ieeFeedback'
import FloatButtonList from '@/components/FloatButtonList'
// import Cookies from 'js-cookie'

import { config, glsConfig, acsConfig, iuopConfig, IUOPOSconfig, IUOPOSIDconfig, iuopBoschConfig, cairConfig, sfbuyConfig, iftpConfig, iscoConfig, cbsConfig, sdmConfig, openAPIConfig, ESGOSConfig } from './config/config'
import { init as trackInit } from '@/utils/TrackSdk'
import cloneDeep from 'lodash-es/cloneDeep'
import MessageNotice from './components/LoginRegisterBox/components/messageNotice.vue'
import { onCLS, onLCP, onTTFB, onFCP, onFID, onFP, onTTI } from '@/utils/reporter/utils/webVitals'
import { WebCLS, WebLCP, WebTTFB, WebFCP, WebFID, WebFP, WebTTI } from '@/utils/reporter/webVitals'
// import Recommend from '@/components/Recommend/index.vue'
//  import '@ibu/feedback/style.css'
// import { render } from '@ibu/feedback'

// import { glsConfig } from './config/config'

export default {
  name: 'App',
  components: {
    FloatServiceOS,
    FloatServiceIUOP,
    // TopSwitchSite,
    ElCookieTerms,
    ElTermsDialog,
    FloatButtonList,
    FloatService,
    MessageNotice,
    // Recommend
  },
  data: function() {
    return {
      initUrl: '',
      isOS: isOS()
    }
  },
  computed: {
    ...mapGetters(['site', 'cookie_terms', 'appLoading', 'language', 'system_source', 'uiConfig', 'siteConfig']),
    isShowCookieTerms() {
      const hidePath = ['/terms'] // 不展示cookie协议政策的路由
      return !hidePath.includes(this.$route.path)
    },
    isShowFloatService() {
      const hidePath = ['/terms'] // 不展示客服助手的路由
      return !hidePath.includes(this.$route.path)
    },
    showRecommend() {
      return this.uiConfig.isRecommendEnabled && this.uiConfig.recommendType === '1' && this.uiConfig.recommendPosition === '1' && this.uiConfig.recommendProductType === '1' && this.uiConfig.recommendProductType !== '2' && this.uiConfig.recommendProductType !== '3' && this.uiConfig.recommendProductType !== '4' && this.uiConfig.recommendProduct
    },
    isChildApp() {
      return !!window.__POWERED_BY_QIANKUN__
    },
    isFromSFBuy() {
      return this.system_source === SF_BUY
    },
    isFromIUOP() {
      return this.system_source === SF_IUOP || this.system_source === IUOP_BOSCH
    },
    isFromIUOPOS() {
      return this.system_source === SF_IUOP_OS
    },
    cookieKey() {
      console.log('%c Line:104 🥤 this.uiConfig.cookieKey || 1', 'color:#6ec1c2', this.uiConfig.cookieKey || 1)
      return this.uiConfig.cookieKey || 1
    },

  },
  watch: {
    language(val) {
      if (!window.__POWERED_BY_QIANKUN__) {
        addIeeFeedbackScript(val)
      }
      Cookies.set('lang', val)
    },
    // site: {
    //   handler(n) {
    //     this.getSmsNoticeChannel({ 'countryCode': n.siteCode, 'language': n.language })
    //   },
    //   deep: true,
    //   immediate: true
    // },
    siteConfig: {
      handler(n) {
        this.setUIConfigBySource()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.initUrl = window.location.href
    const lang = getUrlKey('lang', window.location.href)
    const sysCode = getUrlKey('sysCode', window.location.href)
    const siteCountryCode = getUrlKey('siteCountryCode', window.location.href)
    this.init()
    // 蓝绿环境判断
    this.checkGrayVersionMethod({ lang, sysCode, siteCountryCode })
    this.setUIConfigBySource()
    this.getRegexpRemote()
    this.setGJUTM()
    this.getShowMessageNotice()
    if (!window.__POWERED_BY_QIANKUN__) {
      const envObj = getEnvObj()
      const currentSite = envObj.CURRENT_SITE
      const site = envObj.SITE
      this.$track({ sceneType: 'App', eventType: 'App_View' })

      // 当前访问站点是SG，且url上的sysCode是AMAZON，需要重定向回CN站点
      if ((currentSite !== 'CN') && getUrlKey('sysCode') === AMAZON) {
      // console.log('SG站点，亚马逊', )
      // 写一段helloword
        const url = site['CN'] + '/' + window.location.hash
        window.location.href = url
      } else {
        const urlObj = getHtmlParams()
        console.log('url - paramObj：', urlObj)
        if (urlObj.sysCode === 'SFBUY') {
          const _hmt = _hmt || [];
          (function() {
            const hm = document.createElement('script')
            hm.src = 'https://hm.baidu.com/hm.js?e88f5ca51b7506ee0457a30aa0140c7d'
            const s = document.getElementsByTagName('script')[0]
            s.parentNode.insertBefore(hm, s)
          })()
        }
        // if (!isOS()) {
        //   Logger.init(initConfig)
        // }
        if (this.system_source === GLS) {
          this.handleAddHead()
          this.handleAddBody()
        }

        const preference = Cookies.get('option.preference', 'system_source')
        // 开启了GDPR的分析类
        if (preference) {
          const obj = JSON.parse(preference)
          if (!obj.analytics) {
            removeAnalyticsListCookie()
          } else {
            // if (envObj.ENV === 'PRD') {
            //   addWebFunny()
            // }
          }
        } else {
          removeAnalyticsListCookie()
        }
      }
      addIeeFeedbackScript(this.language)
    }
    if (!isOS()) {
      const inter = setInterval(() => {
        if (performance.getEntriesByName('first-paint').length) {
          clearInterval(inter)
          onFP(WebFP)
          onTTI(WebTTI)
          onCLS(WebCLS)
          onLCP(WebLCP)
          onTTFB(WebTTFB)
          onFCP(WebFCP)
          onFID(WebFID)
        }
      }, 1000)
    }
  },
  methods: {
    ...mapMutations({
      setUIConfig: 'app/SET_UI_CONFIG',
    }),
    ...mapActions({
      setAgreeCookie: 'app/setAgreeCookie',
      // setSysCodeWhiteList: 'app/setSysCodeWhiteList',
      // getSmsNoticeChannel: 'app/getSmsNoticeChannel', // 得到国家的下拉列表
      setCommonUrlParams: 'app/setCommonUrlParams',
      getRegexpRemote: 'site/getRegexpRemote',
      getShowMessageNotice: 'site/getShowMessageNotice'
    }),
    init() {
      // 需要保存下来的 url 参数
      this.setCommonUrlParams(['referrerType', 'referrerCode', 'channelCode'])
      const token = getUrlKey('token', window.location.href)
      const sysCode = getUrlKey('sysCode', window.location.href)
      let redirectUrl = getUrlKey('from', window.location.href)
      if (token) {
        setToken(token)
      }
      try {
        if (redirectUrl) {
          redirectUrl = decodeURIComponent(redirectUrl)
          // 得到 https://www.baidu.com?xx=yy的前端地址
          redirectUrl = redirectUrl.split('?')[0]
        }
        this.$setProperties({ sysCode, redirectUrl })
        const gray_version = Cookies.get('icas_gray_version')
        console.log('gray_version', gray_version)
      } catch (e) {
        console.log(e)
      }
    },
    setUIConfigBySource() {
      // 需要深拷贝 否则configTmp 的值会改变 切换国家时会不生效
      let configTmp = cloneDeep(config)
      if (this.system_source === GLS) {
        configTmp = cloneDeep(glsConfig)
      } else if (this.system_source === ACS) {
        configTmp = cloneDeep(acsConfig)
      } else if (this.system_source === SF_IUOP || this.system_source === SF_IUOP) {
        configTmp = cloneDeep(iuopConfig)
      } else if (this.system_source === SF_BUY) {
        configTmp = cloneDeep(sfbuyConfig)
      } else if (this.system_source === IFTP) {
        configTmp = cloneDeep(iftpConfig)
      } else if (this.system_source === ISCO || this.system_source === ISCOUS || this.system_source === ISCO_OS) {
        configTmp = cloneDeep(iscoConfig)
        document.body.classList.add('isco-active')
      } else if (this.system_source === CBS) {
        configTmp = cloneDeep(cbsConfig)
      } else if (this.system_source === SDM) {
        configTmp = cloneDeep(sdmConfig)
      } else if (this.system_source === OPENAPI) {
        configTmp = cloneDeep(openAPIConfig)
      } else if (this.system_source === ESG_THACSP_CORE_OS) {
        configTmp = cloneDeep(ESGOSConfig)
      } else if (this.system_source === IUOP_BOSCH) {
        configTmp = cloneDeep(iuopBoschConfig)
      } else if (this.system_source === CAIR) {
        configTmp = cloneDeep(cairConfig)
      } else if (this.system_source === SF_IUOP_OS) {
        configTmp = cloneDeep(IUOPOSconfig)
      } else if (this.system_source === SF_IUOP_OS_ID) {
        configTmp = cloneDeep(IUOPOSIDconfig)
      } else {
        document.body.classList.remove('isco-active')
      }

      // 如果是 id 域 那么，直接使用顺丰主题
      if (isId() || isVn()) {
        configTmp.sfTheme = true
      }

      if (configTmp.sfTheme) {
        const curLink = document.querySelector('link')
        document.querySelector('head').removeChild(curLink)
        const link = document.createElement('link')
        link.rel = 'shortcut icon'
        link.href = './favicon.ico'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      if (configTmp.theme) {
        setPrimaryThemeColors(configTmp.theme.buttonBackgroundColor)
        // document.addEventListener('DOMContentLoaded', function() {
        //   console.log('222222222222222222222222222222222222222', configTmp.theme.buttonBackgroundColor)
        // })
        // setTimeout(() => {
        // }, 0)
      }
      // console.log('111111111111111', configTmp.loginMethods.wxQRCodeLogin, this.siteConfig.loginConfig?.personal?.wxEnable)
      // console.log('111111111111111', configTmp.loginMethods.wxQRCodeLogin && !!(this.siteConfig.loginConfig?.personal?.wxEnable ?? true))

      // 根据接口siteConfig的数据和前端数据相互匹配 ~
      if (this.siteConfig.loginConfig?.mergedLogin) {
        configTmp.loginMethods.mobilePhoneLogin = configTmp.loginMethods.mobilePhoneLogin && !!(this.siteConfig.loginConfig?.personal?.mobileEnable ?? true)
        configTmp.loginMethods.emailLogin = configTmp.loginMethods.emailLogin && !!(this.siteConfig.loginConfig?.personal?.emailEnable ?? true)
        configTmp.loginMethods.usernameLogin = configTmp.loginMethods.usernameLogin && !!(this.siteConfig.loginConfig?.personal?.usernameEnable ?? true)
        configTmp.loginMethods.wxQRCodeLogin = configTmp.loginMethods.wxQRCodeLogin && !!(this.siteConfig.loginConfig?.personal?.wxEnable ?? true)
      } else {
        // configTmp.loginMethods.mobilePhoneLogin = true
        // configTmp.loginMethods.emailLogin = false
        // configTmp.loginMethods.usernameLogin = false
        configTmp.loginMethods.mobilePhoneLogin = configTmp.loginMethods.mobilePhoneLogin && !!(this.siteConfig.loginConfig?.personalUnmerge?.mobileEnable ?? true)
        configTmp.loginMethods.emailLogin = configTmp.loginMethods.emailLogin && !!(this.siteConfig.loginConfig?.personalUnmerge?.emailEnable ?? true)
        configTmp.loginMethods.usernameLogin = configTmp.loginMethods.usernameLogin && !!(this.siteConfig.loginConfig?.personalUnmerge?.usernameEnable ?? true)
        configTmp.loginMethods.wxQRCodeLogin = configTmp.loginMethods.wxQRCodeLogin && !!(this.siteConfig.loginConfig?.personalUnmerge?.wxEnable ?? true)
      }
      console.log('1111111111', configTmp.loginMethods.wxQRCodeLogin)
      configTmp.isOldLoginOn = configTmp.isOldLoginOn && !!(this.siteConfig?.topConfig?.changeEnable ?? true)
      configTmp.cooperationConsulting = configTmp.cooperationConsulting && !!(this.siteConfig?.topConfig?.cooperationEnable ?? true)
      configTmp.internationalWebsite = configTmp.internationalWebsite && !!(this.siteConfig?.topConfig?.internationalWebsiteEnable ?? true)
      configTmp.country = configTmp.country && !!(this.siteConfig?.topConfig?.countryOrRegionEnable ?? true)
      configTmp.language = configTmp.language && !!(this.siteConfig?.topConfig?.langEnable ?? true)
      configTmp.isHelpCenterEnabled = configTmp.isHelpCenterEnabled && !!true

      // configTmp.loginMethods.wxQRCodeLogin = false
      // 0 融合登录 1 3要素分开登录
      if (this.siteConfig.loginConfig?.mergedLogin === undefined) {
        configTmp.loginType = 0
      } else {
        configTmp.loginType = this.siteConfig.loginConfig?.mergedLogin ? 0 : 1
      }

      configTmp.specialTag = this.siteConfig.specialTag || null
      if (configTmp.specialTag === 'validCodeOnly') {
        configTmp.loginMethods.usernameLogin = false
      }

      // configTmp.loginType = this.siteConfig.loginConfig?.personal?.mergedLogin ? 0 : 0
      configTmp.businessSystemLogo = this.siteConfig.topConfig?.businessSystemLogo?.url
      if (this.siteConfig.middleConfig?.tiledLogo?.url) { configTmp.tiledLogo = this.siteConfig.middleConfig?.tiledLogo?.url }
      // configTmp.sfInternationalLogo = this.siteConfig.topConfig?.sfInternationalLogo?.url
      configTmp.leftLogo = this.siteConfig.middleConfig?.leftLogo?.url
      configTmp.rightLogo = this.siteConfig.middleConfig?.rightLogo?.url
      // configTmp.tiledEnable = configTmp.tiledEnable && !!false
      configTmp.tiledEnable = configTmp.tiledEnable && !!(this.siteConfig?.middleConfig?.tiledEnable ?? true)
      // configTmp.tiledEnable = false
      const leftDocuments = this.getLeftDocument(this.siteConfig.middleConfig?.leftDocuments)
      configTmp.leftDocuments.lang = leftDocuments?.lang ?? null
      configTmp.leftDocuments.jumpUrl = leftDocuments?.jumpUrl ?? null
      configTmp.leftDocuments.jumpDocument = leftDocuments?.jumpDocument ?? ''
      configTmp.leftDocuments.extDesc = leftDocuments?.extDesc ?? ''
      configTmp.leftDocuments.describe = leftDocuments?.describe ?? ''
      configTmp.leftDocuments.scanningWarn = leftDocuments?.scanningWarn ?? ''
      configTmp.leftDocuments.codeLogo = leftDocuments?.codeLogo?.url ?? ''
      // configTmp.tiledEnable = false
      this.setUIConfig(configTmp)
      // this.setSysCodeWhiteList({})
    },
    getLeftDocument(leftDocuments) {
      const language = this.language
      const leftDocument = leftDocuments?.find(item => item.lang === language)
      return leftDocument || {}
    },
    setGJUTM() {
      trackInit()
      // sessionStorage.setItem('gjUtm', getHtmlParams()['gjUtm'])
    },
    checkGrayVersionMethod(params) {
      // setInterval(async() => {
      //   const res = await checkGrayVersion(params)
      //   const lastVersion = Cookies.get('icas_gray_version')
      //   console.log('result:', res?.data?.curVersion, lastVersion, res?.data?.curVersion && lastVersion && lastVersion !== res.data.curVersion)
      //   if (res?.data?.curVersion && lastVersion && lastVersion !== res.data.curVersion) {
      //     window.location.replace(this.initUrl)
      //   }
      //   console.log(res)
      // }, 10000)
    },
    changeVal(item) {
      if (item.agree && this.cookie_terms.type === this.cookieKey) {
        this.setAgreeCookie(JSON.stringify(item))
      } else if (this.cookie_terms.type === this.cookieKey) {
        removeOptionCookie()
      }
      // 只要点击弹窗的确定按钮就关闭cookie banner
      this.$nextTick(() => {
        if (this.cookie_terms.type === this.cookieKey) {
          this.$refs['closeDialog'].isAgree = true
        }
      })
    },
    handleAddHead() {
      // 加在head
      this.headComment1 = document.createComment('Google Tag Manager')
      this.headComment2 = document.createComment('End Google Tag Manager')
      this.headScript = document.createElement('script')
      this.headScript.type = 'text/javascript'
      this.headScript.id = 'headScript1'
      this.headScript.text = `
          (function(w,d,s,l,i){
          w[l] = w[l]||[];
          w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
          var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.id='headScript2';
          j.src= 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j,f);
          })(window, document, 'script','dataLayer','GTM-K8K7PMH');`
      document.head.appendChild(this.headComment1)
      document.head.appendChild(this.headScript)
      document.head.appendChild(this.headComment2)
    },
    handleAddBody() {
      // 加在body
      this.bodyComment1 = document.createComment('Google Tag Manager (noscript)')
      this.bodyComment2 = document.createComment('End Google Tag Manager (noscript)')
      this.bodyNoscript = document.createElement('noscript')
      this.bodyNoscript.id = 'googleBody'
      this.bodyNoscript.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-K8K7PMH"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`
      const firstTag = document.body.firstChild// 得到页面的第一个元素
      document.body.insertBefore(this.bodyComment2, firstTag)
      document.body.insertBefore(this.bodyNoscript, this.bodyComment2)
      document.body.insertBefore(this.bodyComment1, this.bodyNoscript)
    },
  }
}
</script>
